import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
import { checklist } from '../data/offer';
export function ChecklistSection() {
  return <section className="bg-stage-deep py-16" aria-labelledby="includes-title" data-id="element-54" data-mp="2lyc233hxa9dj">
      <div className="mx-auto max-w-5xl px-4" data-id="element-55" data-mp="2m0epdfroxoek">
        <h2 id="includes-title" className="text-center text-3xl font-extrabold text-white" data-id="element-56" data-mp="2qw3udymhbxi9">Todos los tomos incluyen</h2>
        <div className="mt-9 grid gap-x-10 gap-y-4 md:grid-cols-2" data-id="element-57" data-mp="2c6pk8ob2xc1t">
          {checklist.map(([title, detail], index) => <motion.div key={title} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.28,
          delay: index * 0.02,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex gap-3 rounded-xl p-2" data-id="element-58" data-mp="2h0tr77kchk2w" data-mpi={index}>
              <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-gold" data-id="element-59" data-mp="1y8r71m8hvlnw" />
              <p data-id="element-60" data-mp="1iseilttp61jj">
                <b className="block text-sm text-white" data-id="element-61" data-mp="1irvaf4tumrip">{title}</b>
                <span className="text-sm text-mutedDark" data-id="element-62" data-mp="1dtjzsrvqcczf">{detail}</span>
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}